import React from "react";

import TextStyles from "../../../../../../../Constants/TextStyles";
import Styled from "../../PageOne/PageOne";

const CancellationFee = (props) => {
  const selectedData = props && props.selectedData;

  const heading = "Cancellation Fee";

  return (
    <div
      style={{
        display:
          selectedData &&
          selectedData.cancellation_fee &&
          selectedData.cancellation_fee.required === true
            ? "inline"
            : "none",
      }}
    >
          <Styled.ReviewContentBox>
            <TextStyles.FontSize20px className="mb-3 fw-medium">
              {heading}
            </TextStyles.FontSize20px>
            <TextStyles.FontSize14px className="lh-lg">
                  If the Client terminates this Agreement earlier without cause,
                  Contractor will charge a cancellation fee of
                  <span
                    className="ms-1 fw-semibold"
                  >
                    {selectedData.currency.symbol}
                    {parseFloat(
                      selectedData.cancellation_fee.cancellation_fee_amount || 0
                    ).toFixed(2)}
                  </span>
            </TextStyles.FontSize14px>
          </Styled.ReviewContentBox>
    </div>
  );
};

export default CancellationFee;
